import { DeveloperAccessService } from './service';
import { GetBannerInfoResponse } from './types';
import { ResponseBase } from '@src/api/types';

export const DEVELOPER_ACCESS_QUERY_KEYS = {
  GET_BANNER_INFO: 'GET_BANNER_INFO',
  JPA_FILE_METADATA_SYNC: 'JPA_FILE_METADATA_SYNC',
};

export class DeveloperAccessQueries {
  public static readonly getBannerInfo = (): Promise<GetBannerInfoResponse> => {
    return DeveloperAccessService.getBannerInfo();
  };
  public static readonly jpaFileMetadataSync = (createdDate: string): Promise<ResponseBase> => {
    return DeveloperAccessService.jpaFileMetadataSync(createdDate);
  };
}
